import React, { useState, useEffect } from "react";
import { withRouter, useHistory, Link } from "react-router-dom";
import style from "./logCard.module.scss";
import toPersianNumber from "../../../helpers/actions/toPersianNumber"
import numberWithCommas from "../../../helpers/actions/numberWithCommas"
import momentJalaali from 'moment-jalaali';

const LogCard = (props) => {

    const descriptionType = (value, type) => {
        let result = value
        if (type.includes('محصول') || type.includes('تنوع')) {
            result = 'DKPC - ' + toPersianNumber(result)
        }
        if (type.includes('خرید') || type.includes('تمدید')) {
            result = toPersianNumber(numberWithCommas(result)) + ' تومان'
        }
        return result
    }

    const defineIconColor = title => {
        let classname = 'logIconWrapper'
        if (title.includes('خطا')) {
            classname = 'logIconWrapper_red'
        }
        if (title.includes('ورود به باکس')) {
            classname = 'logIconWrapper_green'
        }
        return classname
    }

    const determinIcon = title => {
        let icon = 'e'
        if (title.includes('حذف')) {
            icon = 'Y'
        }
        if (title.includes('ویرایش') || title.includes('تغییر')) {
            icon = 'r'
        }
        if (title.includes('خطا')) {
            icon = 'n'
        }
        if (title.includes('ساخت') || title.includes('آپلود') || title.includes('تکمیل') || title.includes('افزودن')) {
            icon = 'i'
        }
        if (title.includes('بسته')) {
            icon = 'I'
        }
        if (title.includes('فعال') || title.includes('ارتباط')) {
            icon = 'q'
        }
        if (title.includes('به‌روزرسانی')) {
            icon = 'X'
        }
        if (title.includes('ورود به باکس')) {
            icon = 'f'
        }
        return icon
    }

    return (
        <div className={style.wrapper}>
            {/* style.logIconWrapper */}
            <div className={style[defineIconColor(props.data.title)]}>{determinIcon(props.data.title)}</div>
            <div className={style.cardTitle}>{props.data.title}</div>
            <div className={style.cardChannel}>{descriptionType(props.data.description, props.data.title)}</div>
            <div className={style.cardCausedBy}>
                <div className={style.causedByName}>{typeof props.data.user == 'string' ? '' : props.data.user.name}</div>
                <div>{toPersianNumber(momentJalaali(props.data.date).format('HH:mm'))} - {toPersianNumber(momentJalaali(props.data.date).format('jYYYY/jM/jD'))}</div>
            </div>
        </div>
    )
}

export default withRouter(LogCard);



